import { render, staticRenderFns } from "./ClientFilterSelect.vue?vue&type=template&id=a20079ca"
import script from "./ClientFilterSelect.vue?vue&type=script&lang=js"
export * from "./ClientFilterSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports